import {EventDto} from "../../../../../../../models/event/event-dto";

export class EventRow<T> {
  isActive: boolean = true;
  isOpen: boolean = false;
  eventDto!: EventDto
  orders: T[] = [];
  revenue: number = 0;
  employeeCosts: number = 0;
  netRevenue: number = 0;
  displayedRevenue: number = 0;
}
